import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { distinctUntilChanged, filter, first } from 'rxjs';
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Sentry from '@sentry/angular';
import { Auth0Account } from './accounts/interfaces/accounts.types';
import {
  AnalyticsService,
  RudderstackAnalytics,
} from '@geneplanet/ngx-utils/src/lib/analytics';

declare const window: {
  rudderanalytics: RudderstackAnalytics;
};

@Injectable({
  providedIn: 'root',
})
export class SentryErrorService {
  private account: Auth0Account;

  constructor(
    private router: Router,
    private analyticsService: AnalyticsService
  ) {}

  public setAccount(account: Auth0Account) {
    this.account = account;
  }

  public errorOnMissingUserId() {
    const subscription = this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        distinctUntilChanged()
      )
      .subscribe((event: NavigationEnd) => {
        const anonymousUrls = [
          '/accounts/logged-out',
          '/accounts/check',
          '/accounts/create',
          '/accounts/reset',
          '/onboarding/adrialab/welcome',
          '/onboarding/biolab/welcome',
          '/onboarding/dna/welcome',
          '/onboarding/nipt/welcome',
          '/onboarding/blood/welcome',
          '/onboarding/already-activated',
          '/nipt/nipt-expired',
        ];

        if (anonymousUrls.some((url) => event.url.startsWith(url))) {
          return;
        }

        this.analyticsService
          .loaded()
          .pipe(
            filter((loaded) => loaded),
            first()
          )
          .subscribe(() => {
            if (!this.analyticsService.getUserId()) {
              Sentry.captureMessage(
                `user ${
                  this.account?.sub
                } should be identified, \ncheckExisting: ${
                  this.analyticsService.checkExisting
                }, \nanonymous id: ${this.analyticsService.getAnonymousId()}, \ncustomer id: ${
                  this.account?.['http://schemas.nomnio.com/2017/5/customer']
                }, \nanalytics: ${JSON.stringify(window.rudderanalytics)}`
              );
            }
          });

        subscription.unsubscribe();
      });
  }
}
